export function safeErrorDescription(error: unknown): string {
  // Never serialize messages, URLs, causes, headers or arbitrary error objects.
  // They may carry tokens, passwords or database connection strings.
  if (error instanceof Error) return "Application operation failed";
  if (error instanceof Response) return `Application response failed (${error.status})`;
  return "Application operation failed";
}